import { ReactNode } from 'react';

import { useUpdatePurchasesPermissions } from '../useUpdatePurchasesPermissions';

interface BulkEditAccountingActionPermissionsHandlerProps {
  children: ReactNode;
}

export const BulkEditAccountingActionPermissionsHandler = ({
  children,
}: BulkEditAccountingActionPermissionsHandlerProps) => {
  const { hasUpdatePurchasesPermission } = useUpdatePurchasesPermissions();

  if (!hasUpdatePurchasesPermission) {
    return null;
  }

  return <>{children}</>;
};
